import React from 'react';
import PropTypes from 'prop-types';

import { StyledBox } from './styles';

export const VpPageContainer = ({ children }) => {
  return <StyledBox>{children}</StyledBox>;
};

VpPageContainer.propTypes = {
  children: PropTypes.node
};

export default VpPageContainer;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpPageContainer/VpPageContainer.jsx